<template>
  <!-- Tablet and Desktop -->
  <div :class="{ 'is-group-individual fw-semi': isGroupIndividual }" class="w-100 w-lg-40 p-0">
    <div class="d-flex flex-column flex-lg-row align-items-end align-items-lg-center update-pricing p-0">
      <div :title="`${formatPrice(lastLastNetPrice)}€`" class="td w-lg-25" :class="{ validated: netValidated === true && (isTotal || isGroupType) }">
        <template v-if="!!totalType">
          <span class="d-lg-none">{{ $t("tourPricing.netPrice") }}: </span>
          <span>{{ formatPrice(localNetPrice) }} €</span>
        </template>

        <div v-else class="gap-8">
          <div class="d-lg-none text-nowrap">{{ $t("tourPricing.netPrice") }}:</div>
          <div class="d-flex align-items-center gap-4">
            <v-form-input
              :id="'pricing-net-price-' + id"
              :model-value="localNetPrice"
              title=""
              class="flex-grow-1"
              :class="{
                validated: netValidated === true,
                updatebysupplier: !netValidated && isUpdatedBySupplier && !isTotal,
                updatebysuppliervalidated: !netValidated && isPriceValidated && !isTotal,
              }"
              :disabled="netValidated === true || accepted || isSold"
              :yup-errors-variable="errors.localNetPrice"
              autocomplete="off"
              form-type="input-group"
              onwheel="return false;"
              right-addon="€"
              step=".01"
              type="number"
              @blur="updatePricing(localNetPrice, 'net', 'localNetPrice', 'lastNetPrice')"
              @input="
                (event) => {
                  currentVariablePrice = 'localNetPrice';
                  localNetPrice = event.target.value;
                }
              "
              @keyup.enter="$event.target.blur()"
            />
            <div
              v-if="supplierPrice > 0 || dbPrice > 0"
              class="supplier-price-popover"
              data-bs-toggle="popover"
              :data-bs-content="popoverContent"
              data-bs-html="true"
              data-bs-trigger="hover"
              data-bs-placement="top"
            >
              <v-icon icon="info" size="xs" />
            </div>
          </div>
        </div>
      </div>

      <div class="td w-lg-25">
        <div class="d-lg-none text-nowrap">{{ $t("tourBooking.bookingStatus") }}:</div>

        <v-form
          id="tour-resource-update-reservation-status"
          :yup-errors-variable="errors.status"
          class="w-100"
          form-type="outline"
        >
          <v-select
            id="tour-resource-update-reservation-status"
            v-model="localReservationStatus"
            class="supplier-status-list"
            :class="[`bg-status-${findConceptByKey('tour.reservation_status_type', localReservationStatus).color}`]"
            :clearable="false"
            :options="tourReservationStatusTypes"
            :reduce="(returnValue) => returnValue.key"
            :disabled="isSold"
            @option:selected="updateItemResourceStatus('reservation_status')"
          >
            <template v-slot:no-options>
              <div class="my-4">{{ $t("general.vueSelect.noOptions") }}</div>
            </template>
          </v-select>
        </v-form>
      </div>

      <div class="td w-lg-25">
        <div class="d-lg-none text-nowrap">{{ $t("tourBooking.paymentStatus") }}:</div>

        <v-form
          id="tour-resource-update-reservation-status"
          :yup-errors-variable="errors.status"
          class="w-100"
          form-type="outline"
        >
          <v-select
            id="tour-resource-update-reservation-status"
            v-model="localPaymentStatus"
            class="supplier-status-list"
            :class="[`bg-status-${findConceptByKey('tour.payment_status_type', localPaymentStatus).color}`]"
            :clearable="false"
            :options="tourPaymentStatusTypes"
            :reduce="(returnValue) => returnValue.key"
            :disabled="isSold"
            @option:selected="updateItemResourceStatus('payment_status')"
          >
            <template v-slot:no-options>
              <div class="my-4">{{ $t("general.vueSelect.noOptions") }}</div>
            </template>
          </v-select>
        </v-form>
      </div>

      <div class="td w-lg-25">
        <div class="d-lg-none text-nowrap">{{ $t("tourBooking.invoiceStatus") }}:</div>

        <v-form
          id="tour-resource-update-reservation-status"
          :yup-errors-variable="errors.status"
          class="w-100"
          form-type="outline"
        >
          <v-select
            id="tour-resource-update-reservation-status"
            v-model="localInvoiceStatus"
            class="supplier-status-list"
            :class="[`bg-status-${findConceptByKey('tour.invoice_status_type', localInvoiceStatus).color}`]"
            :clearable="false"
            :options="tourInvoiceStatusTypes"
            :reduce="(returnValue) => returnValue.key"
            :disabled="isSold"
            @option:selected="updateItemResourceStatus('invoice_status')"
          >
            <template v-slot:no-options>
              <div class="my-4">{{ $t("general.vueSelect.noOptions") }}</div>
            </template>
          </v-select>
        </v-form>
      </div>

      <div v-if="isGroupType || isTotal" class="w-15 pe-lg-4 d-flex align-items-center justify-content-center">
        <v-button
          :aria-label="$t('general.button.save')"
          :disabled="accepted || !canUpdatePricing || isSold"
          :title="$t('general.button.save')"
          class="btn-primary p-4"
          variant="icon"
          @click="updatePricingOld"
        >
          <v-icon icon="check" />
        </v-button>
      </div>
    </div>
    <div
      v-if="
        (isIndividual && !!paymentStatus && paymentStatus !== 'pending' && localSplitPayment) ||
        (isGroupIndividual && paymentStatus !== 'pending' && !!localSplitPayment)
      "
      class="d-flex flex-column flex-lg-row amounts"
    >
      <v-form
        id="payment-partial-amount-paid-form"
        :label="$t('general.shared.paid')"
        class="w-50 px-4"
        form-type="outline"
      >
        <v-form-input
          id="payment-partial-amount-paid"
          v-model="localAmountPaid"
          :disabled="accepted || isSold"
          :yup-errors-variable="errors.localAmountPaid"
          autocomplete="off"
          class="form-outline"
          form-type="input-group"
          onwheel="return false;"
          right-addon="€"
          step=".1"
          type="number"
          @blur="updateItemResource()"
          @keyup.enter="$event.target.blur()"
        />
      </v-form>

      <v-form
        id="payment-partial-amount-pending-form"
        :label="$t('general.shared.pending')"
        class="w-50 px-4"
        form-type="outline"
      >
        <v-form-input
          id="payment-partial-amount-pending"
          :model-value="localAmountPending"
          :yup-errors-variable="errors.localAmountPending"
          autocomplete="off"
          class="form-outline"
          disabled
          form-type="input-group"
          onwheel="return false;"
          right-addon="€"
          step=".1"
          type="number"
        />
      </v-form>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, onUpdated, computed, PropType,
} from 'vue';
import { useField } from 'vee-validate';
import { mapState, mapActions } from 'pinia';
import { useI18n } from 'vue-i18n';
import * as yup from 'yup';
import { Popover } from 'bootstrap';
import { VForm, VFormInput } from '@uniqoders/form';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';
import { useUserStore } from '@/stores/user';
import { usePriceStore } from '@/stores/priceCalculation';
import { useConfirm } from '@/composables/useConfirm';
import { useAppStore } from '@/stores/app';
import { IPricingItemSupplierResource } from '@/views/case/parts/TheTourPricing.vue';
import { formatPrice, roundPrice } from '@/composables/pricing';
import api from '@/api';
import useFormValidation from '@/helpers/form';
import { findConceptByKey, mapConcepts } from '@/helpers/ConceptHelper';
import useConcepts from '@/helpers/Concepts';
import vSelect from 'vue-select';

export default defineComponent({
  name: 'VPricingAndStatusUpdate',
  components: {
    vSelect,
    VForm,
    VFormInput,
    VButton,
    VIcon,
  },
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    agency: {
      type: String,
      required: true,
    },
    caseId: {
      type: Number,
      required: true,
    },
    tourId: {
      type: Number,
      required: true,
    },
    accepted: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSold: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGroupType: {
      type: Boolean,
      required: false,
      default: false,
    },
    isIndividual: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGroupIndividual: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTotal: {
      type: Boolean,
      required: false,
      default: false,
    },
    net: {
      type: Number,
      required: false,
      default: 0,
    },
    markup: {
      type: Number,
      required: false,
      default: 0,
    },
    gross: {
      type: Number,
      required: false,
      default: 0,
    },
    netValidated: {
      type: Boolean,
      required: false,
      default: false,
    },
    splitPayment: {
      type: Boolean,
      required: false,
      default: false,
    },
    markToPay: {
      type: Boolean,
      required: false,
      default: false,
    },
    amountPaid: {
      type: Number,
      required: false,
      default: 0,
    },
    amountPending: {
      type: Number,
      required: false,
      default: 0,
    },
    supplierPrice: {
      type: Number,
      required: false,
      default: 0,
    },
    dbPrice: {
      type: Number,
      required: false,
      default: 0,
    },
    tourDayItemId: {
      type: Number,
      required: false,
    },
    tourDayItemResourceId: {
      type: Number,
      required: false,
    },
    tourDayItemResourceIds: {
      type: Array,
      required: false,
    },
    totalType: {
      type: String,
      required: false,
      default: '',
    },
    paymentStatus: {
      type: String,
      required: false,
      default: '',
    },
    reservationStatus: {
      type: String,
      required: false,
      default: '',
    },
    invoiceStatus: {
      type: String,
      required: false,
      default: '',
    },
    slugName: {
      type: String,
      required: false,
      default: '',
    },
    tourDayItemResources: {
      type: Array as PropType<IPricingItemSupplierResource[]>,
      required: false,
      default: () => [],
    },
    isUpdatedBySupplier: {
      type: Boolean,
      default: false,
    },
    isPriceValidated: {
      type: Boolean,
      default: false,
    },
    isNewVersion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [
    'update:net',
    'update:markup',
    'update:gross',
    'update:netValidated',
    'update:splitPayment',
    'update:markToPay',
    'update:amountPaid',
    'update:amountPending',
    'update:paymentStatus',
    'update:reservationStatus',
    'update:invoiceStatus',
    'update:accepted',
    'updateTourPriceChange',
    'updatedIndividualPaid',
    'updatedGroupIndividualPaid',
    'updatedTotalTypePricing',
    'updatedIndividual',
    'updateGroupIndividual',
    'updateGroupType',
    'updateTotalPricing',
    'updatedIndividualNetValidated',
    "updateItemResourceReservationStatus",
    "updateItemResourcePaymentStatus",
    "updateItemResourceInvoiceStatus",
    "updateCaseItemResourceReservationStatus",
    'loadTourPricing',
  ],
  setup(props) {
    const { t } = useI18n();
    const { $confirm: confirmHelper } = useConfirm();
    const appStore = useAppStore();

    const rules = {
      localNetPrice: yup.number().min(0).typeError(t('validations.mustBeNumber')),
      localMarkup: yup.number().min(0).max(100).typeError(t('validations.mustBeNumber')),
      localGrossPrice: yup.number().min(0).typeError(t('validations.mustBeNumber')),
      localNetValidated: yup.boolean(),
      localSplitPayment: yup.boolean(),
      localMarkToPay: yup.boolean(),
      localAmountPaid: yup.number().min(0).typeError(t('validations.mustBeNumber')),
      localAmountPending: yup.number().min(0).typeError(t('validations.mustBeNumber')),
    };

    const initialValues: Record<string, any> = {
      localNetPrice:
        props.isGroupType || props.isTotal
          ? Number(props.net)
          : props.isUpdatedBySupplier
          ? props.supplierPrice
          : Number(props.net),
      localMarkup: Number(props.markup),
      localGrossPrice: Number(props.gross),
      localNetValidated: props.netValidated,
      localSplitPayment: props.splitPayment,
      localMarkToPay: props.markToPay,
      localAmountPaid: Number(props.amountPaid),
      localAmountPending: props.amountPending,
      localPaymentStatus: props.paymentStatus,
      localReservationStatus: props.reservationStatus,
      localInvoiceStatus: props.invoiceStatus,
      localOldPrice: props.isUpdatedBySupplier ? roundPrice(props.net) : roundPrice(props.supplierPrice),
    };

    const form = useFormValidation(rules, initialValues);

    const { value: localNetPrice } = useField<number>('localNetPrice');
    const { value: localMarkup } = useField<number>('localMarkup');
    const { value: localGrossPrice } = useField<number>('localGrossPrice');
    const { value: localNetValidated } = useField<boolean>('localNetValidated');
    const { value: localSplitPayment } = useField<boolean>('localSplitPayment');
    const { value: localMarkToPay } = useField<boolean>('localMarkToPay');
    const { value: localAmountPaid } = useField<number>('localAmountPaid');
    const { value: localAmountPending } = useField<number>('localAmountPending');
    const { value: localPaymentStatus } = useField<string>('localPaymentStatus');
    const { value: localReservationStatus } = useField<string>('localReservationStatus');
    const { value: localInvoiceStatus } = useField<string>('localInvoiceStatus');
    const { value: localOldPrice } = useField<number>('localOldPrice');

    const popoverContent = computed(() => {
      const dbPriceText = t('tourPricing.dbPrice', 'DB Price');
      const supplierPriceText = t('tourPricing.supplierPrice', 'Supplier Price');
      const oldPriceText = t('tourPricing.supplierOldPrice', 'Old Price');

      const lines = [];
      if (props.dbPrice > 0) {
        lines.push(`${dbPriceText}: ${formatPrice(props.dbPrice)}€`);
      }
      if (props.supplierPrice > 0) {
        if (Number(props.net) > 0) {
          lines.push(`${oldPriceText}: ${formatPrice(props.net)}€`);
        }
        lines.push(`${supplierPriceText}: ${formatPrice(props.supplierPrice)}€`);
      }

      return lines.join(' <br> ');
    });

    onUpdated(() => {
      const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
      popoverTriggerList.map((popoverTriggerEl) => {
        if (!Popover.getInstance(popoverTriggerEl)) {
          return new Popover(popoverTriggerEl);
        }
        return null;
      });
    });

    return {
      findConceptByKey,
      ...useConcepts(),
      ...form,
      localNetPrice,
      localMarkup,
      localGrossPrice,
      localNetValidated,
      localSplitPayment,
      localMarkToPay,
      localAmountPaid,
      localAmountPending,
      localPaymentStatus,
      localReservationStatus,
      localInvoiceStatus,
      localOldPrice,
      popoverContent,
      appStore,
      confirmHelper,
      formatPrice,
    };
  },
  data() {
    return {
      priceChange: false,
      lastNetPrice: 0,
      lastLastNetPrice: 0,
      lastMarkup: 0,
      lastLastMarkup: 0,
      lastGrossPrice: 0,
      lastLastGrossPrice: 0,
      currentVariablePrice: '',
      canUpdatePricing: false,
      timeout: null as any,
    };
  },
  computed: {
    ...mapState(useUserStore, ["currentTour"]),
    oldPrice() {
      return this.supplierPrice !== 0 ? roundPrice(this.supplierPrice) : roundPrice(this.localNetPrice);
    },
    tourReservationStatusTypes(): any {
      if (!!this.concepts && this.concepts["tour.reservation_status_type"]) {
        return mapConcepts(this.concepts["tour.reservation_status_type"]).sort((a: any, b: any) => {
          const nameA = a.label?.toLowerCase() || "";
          const nameB = b.label?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
      }

      return [];
    },
    tourPaymentStatusTypes(): any {
      if (!!this.concepts && this.concepts["tour.payment_status_type"]) {
        return mapConcepts(this.concepts["tour.payment_status_type"]).sort((a: any, b: any) => {
          const nameA = a.label?.toLowerCase() || "";
          const nameB = b.label?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
      }

      return [];
    },
    tourInvoiceStatusTypes(): any {
      if (!!this.concepts && this.concepts["tour.invoice_status_type"]) {
        return mapConcepts(this.concepts["tour.invoice_status_type"]).sort((a: any, b: any) => {
          const nameA = a.label?.toLowerCase() || "";
          const nameB = b.label?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
      }

      return [];
    },
  },
  watch: {
    localNetPrice(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.priceChange = true;
      }
    },
    net(newValue, oldValue) {
      this.lastNetPrice = Number(newValue);
      this.lastLastNetPrice = Number(oldValue);
      if (newValue !== oldValue) {
        const priceStore = usePriceStore();
        priceStore.setCheckUpdate(!priceStore.updatingAmount);
        this.resetInitialFormValues();
      }
    },
    markup(newValue, oldValue) {
      this.lastMarkup = Number(newValue);
      this.lastLastMarkup = Number(oldValue);
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    gross(newValue, oldValue) {
      this.lastGrossPrice = Number(newValue);
      this.lastLastGrossPrice = Number(oldValue);
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    netValidated(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    splitPayment(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    markToPay(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    amountPaid(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    amountPending(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    paymentStatus(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    reservationStatus(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
    invoiceStatus(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetInitialFormValues();
      }
    },
  },
  methods: {
    ...mapActions(useUserStore, ["setCurrentTour"]),
    resetInitialFormValues() {
      this.resetForm({
        values: {
          localNetPrice:
            this.isGroupType || this.isTotal
              ? roundPrice(this.net)
              : this.isUpdatedBySupplier
              ? roundPrice(this.supplierPrice)
              : roundPrice(this.net),
          localMarkup: roundPrice(this.markup),
          localGrossPrice: roundPrice(this.gross),
          localNetValidated: this.netValidated,
          localSplitPayment: this.splitPayment,
          localMarkToPay: this.markToPay,
          localAmountPaid: roundPrice(this.amountPaid),
          localAmountPending: roundPrice(this.amountPending),
          localPaymentStatus: this.paymentStatus,
          localInvoiceStatus: this.invoiceStatus,
          localReservationStatus: this.reservationStatus,
        },
      });

      this.currentVariablePrice = '';
    },
    async updatePricing(
      updatedValue: number,
      updatedPrice: string,
      variable: string,
      lastVariable: string,
    ) {
      this.currentVariablePrice = variable;

      if (this.isTotal || this.isGroupType) {
        this.canUpdatePricing = this.priceChange && updatedValue !== this[lastVariable];
        return;
      }

      if (this.priceChange && updatedValue !== this[lastVariable]) {
        await this.doUpdatePricing(updatedValue, updatedPrice, variable, lastVariable);
        this.$emit('loadTourPricing');
      }
    },
    async doUpdatePricing(
      updatedValue: number,
      updatedPrice: string,
      variable: string,
      lastVariable: string,
    ) {
      this.toggleAccepted();
      try {
        this.$emit('updateTourPriceChange', true);
        const roundedValue = roundPrice(updatedValue);
        this[variable] = roundedValue;

        let response;

        if (this.isNewVersion && (this.isIndividual || this.isGroupIndividual)) {
          const data: Record<string, any> = {
            net_price: roundedValue,
          };

          if (this.isIndividual) {
            data.resourceId = this.tourDayItemResourceId ?? (this.tourDayItemResourceIds ?? [])[0];
            response = await api.case.caseUpdatePriceIndividual(this.agency, this.caseId, data);
          } else {
            data.resourceIds = this.tourDayItemResourceIds ?? [];
            response = await api.case.caseUpdatePriceBulk(this.agency, this.caseId, data);
          }

          this.$toast.success(this.$t('general.shared.savedChanges'));
          return;
        } else {
          const data: Record<string, any> = {
            resources_id: this.tourDayItemResourceId ? [this.tourDayItemResourceId] : this.tourDayItemResourceIds,
            updated_price: updatedPrice,
            updated_value: updatedValue,
          };

          if (this.isTotal) {
            response = await api.tourPricing.updateTourTotalPrices(this.agency, this.caseId, this.tourId, data);

            this.$toast.success(this.$t("general.shared.savedChanges"));

            const totalResponse = {
              grossPrice: response.grossPrice,
              markup: response.markup,
              netPrice: response.netPrice,
            };

            this.canUpdatePricing = false;

            this.$emit("updateTotalPricing", totalResponse);
          } else if (this.isIndividual || this.isGroupIndividual) {
            data.resources_id = this.tourDayItemResourceIds;

            response = await api.tourPricing.updatePriceByGroup(this.agency, this.caseId, this.tourId, data);

            const tourData = {
              id: this.tourId,
              agency: this.agency,
              clientTourId: Number(this.caseId),
            };

            const params = {
              expand: ['client', 'paxs', 'featuredImage', 'quotes', 'invoicesReceived', 'clientTour'],
            };

            await this.setCurrentTour(tourData, params);
            if (this.isIndividual && !!this.tourDayItemResourceId) {
              for (const group of response.groups) {
                const itemResource = group.items.find((item: any) => item.id === this.tourDayItemResourceId);

                if (!!itemResource) {
                  this.emitPriceValues(itemResource.net_value, itemResource.markup_value, itemResource.gross_value);

                  if (this.paymentStatus && this.paymentStatus === "partial") {
                    this.$emit("update:amountPending", itemResource.net_value - this.amountPaid);
                  }

                  break;
                }
              }

              this.$emit("updatedIndividual");
            } else {
              this.emitPriceValues(
                response.groups[0].net_value,
                response.groups[0].markup_value,
                response.groups[0].gross_value
              );

              if (!!this.tourDayItemResources && this.tourDayItemResources.length > 0) {
                const tourDayItemResourcesLocal = this.tourDayItemResources;

                response.groups[0].items.forEach((item: any) => {
                  const resource = tourDayItemResourcesLocal.find(
                    (resource: IPricingItemSupplierResource) => resource.id === item.id
                  );

                  if (!!resource) {
                    resource.netPrice = roundPrice(item.net_value);
                    resource.markup = roundPrice(item.markup_value);
                    resource.grossPrice = roundPrice(item.gross_value);
                    resource.isUpdatedBySupplier = false;
                  }
                });
              }

              this.$emit("updateGroupIndividual", response.groups[0].items);
            }

            const groupTypeResponse = {
              grossPrice: roundPrice(response.total.type.gross_value),
              markup: roundPrice(response.total.type.markup_value),
              netPrice: roundPrice(response.total.type.net_value),
            };

            this.$emit("updateGroupType", groupTypeResponse);

            this.emitTotalPricing(response.total.tour);
            this.$toast.success(this.$t("general.shared.savedChanges"));
          } else if (this.isGroupType) {
            data.type = this.totalType;

            response = await api.tourPricing.updateAllMarkupByType(this.agency, this.caseId, this.tourId, data);

            this.canUpdatePricing = false;

            this.emitPriceValues(
              response.groups[0].net_value,
              response.groups[0].markup_value,
              response.groups[0].gross_value
            );

            this.$emit("updatedTotalTypePricing", response.groups[0].items);

            this.emitTotalPricing(response.total.tour);
          }
        }
      } catch (e: any) {
        this[variable] = this[lastVariable];

        this.currentVariablePrice = '';

        console.error(e);

        this.$toast.error(e.response?.data?.message ?? e.message);
      } finally {
        this.toggleAccepted();
        this.$emit('updateTourPriceChange', false);
      }
    },
    async updatePricingOld() {
      const confirmed = await this.confirmHelper.confirm({
        title: this.$t('tourPricing.updatePriceTitle'),
        text: this.isTotal
          ? this.$t('tourPricing.updateTotalPriceText', {
              newTotal: this.localNetPrice.toString().replace('.', ','),
            })
          : this.$t('tourPricing.updatePriceText'),
      });

      if (confirmed) {
        await this.doUpdatePricing(this.localNetPrice, 'net', 'localNetPrice', 'lastNetPrice');
      } else {
        this.localNetPrice = this.lastNetPrice;
        this.priceChange = false;
        this.canUpdatePricing = false;
      }
    },
    emitPriceValues(netPrice: number, markup: number, grossPrice: number) {
      this.$emit('update:net', roundPrice(netPrice));
      this.$emit('update:markup', roundPrice(markup));
      this.$emit('update:gross', roundPrice(grossPrice));
    },
    emitTotalPricing(response: any) {
      const totalResponse = {
        grossPrice: roundPrice(response.gross_value),
        markup: roundPrice(response.markup_value),
        netPrice: roundPrice(response.net_value),
      };

      this.$emit("updateTotalPricing", totalResponse);
    },
    async validateNetPrice() {
      this.$emit('updateTourPriceChange', true);
      try {
        const data = {
          resourceId: this.tourDayItemResourceIds,
          is_validated: !!this.localNetValidated,
        };
        await api.case.caseNetValidated(this.agency, this.caseId, data);
        this.$emit('update:netValidated', this.localNetValidated);

        if (this.isGroupIndividual && !!this.tourDayItemResources && this.tourDayItemResources.length > 0) {
          this.tourDayItemResources.forEach((resource: IPricingItemSupplierResource) => {
            resource.netValidated = !!this.localNetValidated;
          });
        } else {
          this.$emit('updatedIndividualNetValidated');
        }

        this.$emit('loadTourPricing');
        this.$emit('updateTourPriceChange', false);
        this.$toast.success(this.$t('general.shared.savedChanges'));
      } catch (e: any) {
        console.error(e);

        this.$toast.error(e.response?.data?.message ?? e.message);
      }
    },
    async updateItemResource() {
      if (this.meta.valid) {
        try {
          this.toggleAccepted();

          const data = {
            resources_id: this.tourDayItemResourceIds,
            updated_price: 'amount_paid',
            updated_value: this.localAmountPaid,
          };

          const response = await api.tourPricing.updateAmountPaid(
            !!this.slugName ? this.slugName : this.agency,
            this.caseId,
            this.tourId,
            data,
          );

          const group = response.groups[0];

          this.$emit('update:amountPaid', group.amount_paid);
          this.$emit('update:amountPending', group.amount_pending);

          if (this.isIndividual) {
            const resource = response.groups[0].items[0];

            this.$emit('update:netValidated', resource.net_validated);
            this.$emit('update:paymentStatus', resource.payment_status);
            this.$emit('updatedIndividualPaid');
          } else if (this.isGroupIndividual && !!this.tourDayItemResources && this.tourDayItemResources.length > 0) {
            group.items.forEach((item: any) => {
              const resource = this.tourDayItemResources.find(
                (resource: IPricingItemSupplierResource) => resource.id === item.id,
              );

              if (!!resource) {
                resource.amountPaid = item.amount_paid;
                resource.amountPending = item.amount_pending;
                resource.paymentStatus = item.payment_status;
                resource.netValidated = item.net_validated;
              }
            });

            this.$emit('updatedGroupIndividualPaid');
          }
        } catch (e: any) {
          console.error(e);

          this.$toast.error(e.response?.data?.message ?? e.message);
        } finally {
          this.toggleAccepted();
        }
      }
    },
    async doCaseItemUpdatePricing(updatedValue: number, updatedPrice: string) {
      this.toggleAccepted();
      try {
        this.$emit('updateTourPriceChange', true);
        const data = {
          updated_price: updatedPrice,
          updated_value: updatedValue,
          tour_day_item_id: this.id,
          type: this.totalType,
        };

        const response = await api.tourPricing.updateAllMarkupByType(
          !!this.slugName ? this.slugName : this.agency,
          this.caseId,
          this.tourId,
          data,
        );

        if (response) {
          this.$emit('loadTourPricing', false, response);
          this.priceChange = false;
          this.$toast.success(this.$t('general.shared.savedChanges'));
        }
      } catch (e: any) {
        console.error(e);
        this.$toast.error(e.response?.data?.message ?? e.message);
      } finally {
        this.$emit('updateTourPriceChange', false);
        this.toggleAccepted();
      }
    },
    toggleAccepted() {
      this.$emit('update:accepted', !this.accepted);
    },
    debouncedEmit(emitted: string, value: any) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.$emit(`update:${emitted}`, value);
      }, 250);
    },
    async updateItemResourceStatus(type: string) {
      if (this.isNewVersion) {
        await this.updateCaseItemResourceReservationStatus(type);
      } else {
        await this.updateItemResourceReservationStatus(type);
      }
    },
    async updateCaseItemResourceReservationStatus(type: string) {
      try {
        this.toggleAccepted();
        this.$emit("updateTourPriceChange", true);

        let status = "";
        let response;

        if (type === "reservation_status") {
          status = this.localReservationStatus;
        } else if (type === "payment_status") {
          status = this.localPaymentStatus;
        } else {
          status = this.localInvoiceStatus;
        }

        const payload: Record<string, any> = {
          status: status,
          type: type.split("_")[0] === 'reservation' ? 'booking' : type.split("_")[0],
        };
        const resourceIds = this.tourDayItemResourceIds ?? [];
        if (resourceIds.length > 1) {
          payload.resourceIds = resourceIds;
          response = await api.case.caseUpdateStatusBulk(this.agency, this.caseId, payload);
        } else {
          payload.resourceId = resourceIds[0];
          response = await api.case.caseUpdateStatusIndividual(this.agency, this.caseId, payload);
        }

        if (response) {
          this.$toast.success(this.$t("general.shared.savedChanges"));
        }
        this.$emit("loadTourPricing");
      } catch (e: any) {
        console.error(e);
        this.$toast.error(e.response?.data?.message ?? e.message);
      } finally {
        this.$emit("updateTourPriceChange", false);
        this.resetInitialFormValues();
        this.toggleAccepted();
      }
    },
    async updateItemResourceReservationStatus(type: string) {
      try {
        this.toggleAccepted();

        let status = "";

        if (type === "reservation_status") {
          status = this.localReservationStatus;
        } else if (type === "payment_status") {
          status = this.localPaymentStatus;
        } else {
          status = this.localInvoiceStatus;
        }

        const data = {
          status: status,
          status_type: type.split("_")[0],
          resources_id: this.tourDayItemResourceIds,
        };

        await api.tourDayItemResource.updateStatusBulk(
          this.agency,
          this.caseId,
          this.tourId,
          data
        );

        this.$toast.success(this.$t("general.shared.savedChanges"));
        this.$emit("loadTourPricing");
      } catch (e: any) {
        console.error(e);
        this.$toast.error(e.response?.data?.message ?? e.message);
      } finally {
        this.resetInitialFormValues();
        this.toggleAccepted();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.supplier-price-popover {
  cursor: pointer;
  z-index: 2;
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #f9c3ee;
  flex: none;
}
:deep(.v-form-label),
:deep(.form-check-label) {
  font-size: 0.75rem !important;
}

.is-group-individual {
  :deep(.form-control) {
    font-weight: 600;
  }
}

.is-mobile {
  @media (max-width: 992px) {
    .update-pricing {
      &:not(.is-total) {
        .td {
          padding-inline: 0;
          padding-block: 0.25rem;
          width: 100%;
        }
      }
    }

    .amounts {
      .form-outline {
        width: 100% !important;
      }
    }
  }
}

.update-pricing {
  .validated {
    background-color: #e0f2fe !important;

    :deep(.form-control),
    :deep(.input-group-text) {
      background-color: #e0f2fe !important;
    }

    :deep(.form-control:disabled),
    :deep(.form-control[disabled]),
    :deep(.input-group-text:disabled),
    :deep(.input-group-text[disabled]) {
      background-color: #e0f2fe !important;
      opacity: 1 !important;
    }
  }

  .updatebysupplier {
    :deep(.form-control),
    :deep(.input-group-text) {
      background-color: #f9c3ee !important;
    }
  }

  .updatebysuppliervalidated {
    :deep(.form-control),
    :deep(.input-group-text) {
      background-color: #dcfce7 !important;
    }

    :deep(.form-control:disabled),
    :deep(.form-control[disabled]),
    :deep(.input-group-text:disabled),
    :deep(.input-group-text[disabled]) {
      background-color: #dcfce7 !important;
      opacity: 1 !important;
    }
  }

  &:not(.is-total) {
    .td {
      padding-inline: 0.25rem;
      width: calc(100% / 3);
    }
  }

  :deep(.form-control) {
    padding-inline: 0.5rem !important;
    min-height: 24px !important;
    height: 24px !important;
    font-size: 0.8rem !important;
  }

  :deep(.input-group-text) {
    height: 24px !important;
    padding: 0 4px !important;
    font-size: 0.8rem !important;
  }

  &.is-total {
    display: flex !important;
    width: 100%;

    .td {
      padding-inline: 0.375rem;
      font-weight: 600;
      width: calc(86% / 3);
    }

    :deep(.form-control) {
      padding-inline: 0.5rem !important;
      font-weight: 600;
    }

    :deep(.input-group-text) {
      font-weight: 500;
    }
  }
}

.supplier-status-list :deep(.vs__search) {
  padding-inline: 0 !important;
  min-height: 24px !important;
}

.supplier-status-list :deep(.vs__selected) {
  padding-inline: 0.25rem !important;
  min-height: 24px !important;
  font-size: 0.8rem !important;
  margin: 0 !important;
}

.supplier-status-list :deep(.vs__actions) {
  padding: 0 !important;
  padding-right: 3px !important;
}

.supplier-status-list :deep(.vs__dropdown-toggle) {
  min-height: 24px !important;
}

.supplier-status-list :deep(.vs__dropdown-menu) {
  min-width: 100px !important;
  font-size: 0.8rem !important;
}
</style>
